import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { DocumentService } from 'src/app/services/document.service';
import { FolderNode, IDocumentFolderPickerDialog } from 'src/app/shared/interfaces/IDocument';
import { DocumentFolderTreeNodeComponent } from './document-folder-tree-node.component';

@Component({
  standalone: true,
  selector: 'app-document-folder-picker-dialog',
  templateUrl: './document-folder-picker-dialog.component.html',
  styleUrl: './document-folder-picker-dialog.component.scss',
  imports: [MaterialModule, TranslateModule, DocumentFolderTreeNodeComponent]
})
export class DocumentFolderPickerDialogComponent implements OnInit {
  root: FolderNode;
  selected: FolderNode | null = null;

  constructor(
    public dialogRef: MatDialogRef<DocumentFolderPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: IDocumentFolderPickerDialog,
    public documentService: DocumentService,
    private translateService: TranslateService
  ) {
    this.root = this.createNode('', this.translateService.instant('root'));
  }

  ngOnInit() {
    this.selected = this.root;
    this.root.expanded = true;
    this.loadChildren(this.root);
  }

  select(node: FolderNode) {
    this.selected = node;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close({ path: this.selected?.path ?? '' });
  }

  loadChildren(node: FolderNode) {
    node.loading = true;
    this.documentService.getDocuments(node.path || null).subscribe({
      next: (res) => {
        node.children = (res.dirs ?? []).map((dir: { path: string; name: string }) => this.createNode(dir.path, dir.name));
        node.childrenLoaded = true;
        node.loading = false;
      },
      error: () => {
        node.childrenLoaded = true;
        node.loading = false;
      }
    });
  }

  private createNode(path: string, name: string): FolderNode {
    return { path, name, children: [], childrenLoaded: false, loading: false, expanded: false };
  }
}
